<div id="semi-donut">
    <apx-chart [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [grid]="chartOptions.grid"
        [plotOptions]="chartOptions.plotOptions"
        [responsive]="chartOptions.responsive"
        [fill]="chartOptions.fill">
    </apx-chart>
</div>